var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(this.$options.name))]),_vm._l((_vm.testCases),function(testGroup,index){return _c('TestCase',{key:index,attrs:{"test-group":testGroup}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }